{
  "title": "الفوترة",
  "description": "تستلم Dodo Payments المدفوعات وتصدر الفواتير.",
  "tabs": {
    "label": "أقسام الفوترة",
    "overview": "نظرة عامة",
    "methods": "طرق الدفع",
    "details": "بيانات الفوترة",
    "invoices": "الفواتير",
    "payments": "المدفوعات"
  },
  "roles": {
    "readOnly": "الدفع وتعديل الفوترة متاحان للمالك والمدير وعضو الفوترة فقط."
  },
  "kinds": {
    "first_charge": "أول دفعة",
    "renewal": "تجديد",
    "plan_change": "تغيير الباقة",
    "ai_credits": "نقاط الذكاء الاصطناعي"
  },
  "failure": {
    "card_declined": "رفض البنك الدفع. جرّب طريقة دفع أخرى أو تواصل مع بنكك.",
    "insufficient_funds": "رصيد البطاقة غير كافٍ. اشحن البطاقة أو استخدم طريقة دفع أخرى.",
    "expired_card": "انتهت صلاحية البطاقة. أضف بطاقة جديدة في صفحة الدفع ثم حاول مرة أخرى.",
    "authentication_failed": "لم يكتمل تحقق البنك. حاول مرة أخرى وأكمل خطوة التحقق."
  },
  "failureShort": {
    "card_declined": "رفضها البنك",
    "insufficient_funds": "الرصيد غير كافٍ",
    "expired_card": "البطاقة منتهية",
    "authentication_failed": "لم يكتمل التحقق"
  },
  "amounts": {
    "subtotal": "المجموع",
    "vat": "ضريبة القيمة المضافة {{rate}}",
    "vatShort": "الضريبة {{rate}}",
    "vatZeroShort": "بدون ضريبة (خارج السعودية)",
    "total": "الإجمالي",
    "dueNow": "المطلوب الآن",
    "inclVat": "شامل الضريبة",
    "inclVatRate": "شامل الضريبة {{rate}}",
    "zeroRated": "بدون ضريبة: الخدمات المقدمة للعملاء خارج السعودية خاضعة لنسبة صفر."
  },
  "lines": {
    "period": "من {{from}} إلى {{to}}",
    "subscription": "باقة {{plan}}، {{cycle}}",
    "proration": "باقة {{plan}}، {{cycle}}، باقي الفترة",
    "prorationCredit": "رصيد الوقت غير المستخدم من باقة {{plan}}، {{cycle}}",
    "aiCredits_zero": "{{credits}} نقطة ذكاء اصطناعي",
    "aiCredits_one": "{{credits}} نقطة ذكاء اصطناعي (حزمة واحدة)",
    "aiCredits_two": "{{credits}} نقطة ذكاء اصطناعي (حزمتان)",
    "aiCredits_few": "{{credits}} نقطة ذكاء اصطناعي ({{count}} حزم)",
    "aiCredits_many": "{{credits}} نقطة ذكاء اصطناعي ({{count}} حزمة)",
    "aiCredits_other": "{{credits}} نقطة ذكاء اصطناعي ({{count}} حزمة)",
    "extraAccounts_zero": "بدون حسابات إضافية",
    "extraAccounts_one": "حساب استضافة إضافي واحد",
    "extraAccounts_two": "حسابا استضافة إضافيان",
    "extraAccounts_few": "{{count}} حسابات استضافة إضافية",
    "extraAccounts_many": "{{count}} حساب استضافة إضافي",
    "extraAccounts_other": "{{count}} حساب استضافة إضافي"
  },
  "stepper": {
    "less": "أقل",
    "more": "أكثر"
  },
  "mock": {
    "payments": "وضع العرض: لا يوجد دفع حقيقي ولا يُخصم أي مبلغ."
  },
  "trial": {
    "badge_zero": "آخر يوم في التجربة",
    "badge_one": "يتبقى يوم واحد في التجربة",
    "badge_two": "يتبقى يومان في التجربة",
    "badge_few": "يتبقى {{count}} أيام في التجربة",
    "badge_many": "يتبقى {{count}} يوم في التجربة",
    "badge_other": "يتبقى {{count}} يوم في التجربة",
    "title": "جهّز الدفع قبل أن تنتهي التجربة في {{date}}",
    "body": "جهّز الدفع ليستمر السيرفر بعد التجربة. بدونه تُقفل لوحة التحكم عند نهاية التجربة، وتستمر المواقع والبريد في العمل.",
    "noChargeNow": "لا نخصم أي مبلغ اليوم.",
    "steps": {
      "started": "بدأت التجربة",
      "firstCharge": "أول دفعة في {{date}}",
      "setUp": "جهّز الدفع قبل {{date}}",
      "setUpDone": "تم تجهيز الدفع"
    },
    "firstChargeLabel": "أول دفعة",
    "cancelAnytime": "يمكنك الإلغاء في أي وقت قبل نهاية التجربة دون خصم أي مبلغ.",
    "titleSet": "التجربة تنتهي في {{date}}",
    "bodySet": "كل شيء جاهز. نخصم من طريقة الدفع المحفوظة لدى Dodo Payments عند نهاية التجربة، وتصلك الفاتورة بالبريد.",
    "setUp": "جهّز الدفع",
    "ready": "جاهز",
    "notReady": "الدفع غير جاهز"
  },
  "alerts": {
    "label": "تنبيهات الفوترة",
    "paymentFailed": {
      "title": "تعذّر دفع تجديد {{server}} بمبلغ",
      "action": "ادفع الآن",
      "retry": "سنحاول مرة أخرى في {{date}}.",
      "grace": "يعمل السيرفر كالمعتاد حتى {{date}}، ثم تُقفل لوحة التحكم حتى تدفع. تستمر المواقع والبريد في العمل."
    },
    "cancelScheduled": "أُلغي اشتراك {{server}} وينتهي في {{date}}، وعندها تُقفل لوحة التحكم. تستمر المواقع والبريد في العمل.",
    "changeScheduled": "ينتقل {{server}} إلى باقة {{plan}}، {{cycle}}، في {{date}}.",
    "detailsIncomplete": "أضف بيانات الفوترة لتصدر فواتيرك باسم شركتك ورقمها الضريبي",
    "completeDetails": "أضف البيانات",
    "locked": {
      "title": "لوحة تحكم {{server}} مقفلة",
      "action": "جدّد الآن"
    },
    "paymentNeeded": {
      "title": "{{server}} بانتظار أول دفعة",
      "body": "ادفع أول فترة لتكمل تثبيت السيرفر.",
      "action": "ادفع"
    }
  },
  "figures": {
    "nextCharge": "الدفعة القادمة",
    "none": "لا يوجد",
    "nextChargeOn": "في {{date}}",
    "nothingScheduled": "لا يوجد تجديد مجدول.",
    "monthly": "التكلفة الشهرية",
    "monthlyHint": "كل السيرفرات، شهريًا، بدون الضريبة",
    "method": "طريقة الدفع الافتراضية",
    "noMethod": "لا يوجد",
    "noMethodHint": "تُحفظ مع أول دفعة",
    "manage": "تحديث",
    "details": "التفاصيل",
    "methodHint": "للتجديدات وحزم النقاط التلقائية"
  },
  "subscriptions": {
    "title": "الاشتراكات",
    "description": "لكل سيرفر اشتراك مستقل.",
    "empty": {
      "title": "لا توجد اشتراكات بعد",
      "body": "كل سيرفر تضيفه له اشتراك خاص به.",
      "action": "إضافة سيرفر"
    },
    "when": {
      "trial": "تجربة حتى {{date}}",
      "pending": "تبدأ الفوترة عند تفعيل السيرفر",
      "failed": "فشل الدفع في {{date}}.",
      "retry": "المحاولة القادمة في {{date}}.",
      "ends": "ينتهي في {{date}}",
      "renews": "يتجدد في {{date}}",
      "change": "ينتقل إلى {{plan}}، {{cycle}}، في {{date}}",
      "incomplete": "بانتظار أول دفعة قبل التثبيت",
      "trialNoPayment": "تنتهي التجربة في {{date}} والدفع غير جاهز",
      "locksOn": "تُقفل لوحة التحكم في {{date}} إذا لم تدفع."
    },
    "actions": {
      "change": "غيّر الباقة",
      "pay": "ادفع الآن",
      "dropChange": "الاحتفاظ بالباقة الحالية",
      "keep": "الإبقاء على الاشتراك",
      "server": "صفحة باقة السيرفر",
      "invoices": "فواتير هذا السيرفر",
      "more": "إجراءات أخرى",
      "payFor": {
        "first_period": "ادفع أول فترة",
        "trial_conversion": "جهّز الدفع",
        "past_due": "ادفع الآن",
        "renewal": "جدّد الآن"
      }
    },
    "perYear": "سنويًا",
    "perMonth": "شهريًا",
    "removedServer": "سيرفر محذوف",
    "changeDropped": "تم إلغاء التغيير المجدول، وتبقى الباقة الحالية."
  },
  "recent": {
    "title": "آخر الفواتير",
    "all": "كل الفواتير"
  },
  "methods": {
    "title": "طرق الدفع",
    "description": "تُستخدم الطريقة الافتراضية للتجديدات وحزم النقاط التلقائية.",
    "default": "الافتراضية",
    "endingIn": "{{brand}} المنتهية بـ {{last4}}",
    "trialTitle": "جهّز الدفع قبل نهاية التجربة",
    "trialBody": "احفظ طريقة الدفع ليستمر السيرفر بعد التجربة. لا نخصم أي مبلغ اليوم.",
    "empty": {
      "title": "لا توجد طرق دفع بعد",
      "body": "تُحفظ طريقة الدفع مع أول دفعة، ثم تظهر هنا."
    },
    "manage": "تحديث طريقة الدفع",
    "where": {
      "title": "أين تُحفظ طرق الدفع",
      "body": "تحفظ Dodo Payments طرق الدفع، ولا نخزن بيانات البطاقات لدينا. نعرض نوع البطاقة وآخر 4 أرقام فقط، أو حساب PayPal. تحل الطريقة الجديدة مكان الحالية في كل اشتراكاتك."
    },
    "added": "أُضيفت في {{date}}",
    "paypalAccount": "حساب PayPal {{account}}"
  },
  "change": {
    "title": "غيّر الباقة",
    "description": "الباقة الحالية: {{plan}}، {{cycle}}.",
    "confirm": "أكّد التغيير",
    "continueToPay": "متابعة للدفع",
    "pickOther": "اختر باقة أو دورة فوترة أخرى لترى التغيير.",
    "prorationNote": "تدفع فقط عن المتبقي من الفترة الحالية، بعد خصم الوقت غير المستخدم من باقتك الحالية.",
    "scheduled": "تمت جدولة الانتقال إلى {{plan}} في {{date}}",
    "applied": "أصبح السيرفر على باقة {{plan}}",
    "timing": {
      "now": "يُطبَّق الآن",
      "periodEnd": "يُطبَّق في {{date}} مع نهاية الفترة الحالية. لا نخصم أي مبلغ الآن.",
      "free": "يُطبَّق الآن، ولا يوجد دفع حتى تبدأ الفوترة."
    },
    "nextRenewal": "التجديد القادم في {{date}}:"
  },
  "invoices": {
    "caption": "الفواتير",
    "search": "ابحث برقم الفاتورة",
    "cols": {
      "number": "الفاتورة",
      "date": "التاريخ",
      "servers": "السيرفرات",
      "amount": "المبلغ",
      "vat": "الضريبة",
      "total": "الإجمالي",
      "status": "الحالة"
    },
    "filters": {
      "status": "الحالة",
      "kind": "النوع",
      "server": "السيرفر"
    },
    "actions": {
      "view": "عرض الفاتورة",
      "pay": "ادفع الآن",
      "download": "تنزيل الفاتورة"
    },
    "empty": {
      "title": "لا توجد فواتير بعد",
      "body": "تظهر الفواتير هنا بعد أول دفعة."
    }
  },
  "payments": {
    "caption": "المدفوعات",
    "search": "ابحث برقم الفاتورة",
    "cols": {
      "date": "التاريخ",
      "invoice": "الفاتورة",
      "method": "الطريقة",
      "amount": "المبلغ",
      "status": "الحالة"
    },
    "kind": {
      "charge": "دفعة",
      "retry": "إعادة محاولة",
      "refund": "استرداد"
    },
    "automatic": "تلقائي",
    "filters": {
      "status": "الحالة"
    },
    "empty": {
      "title": "لا توجد مدفوعات",
      "body": "كل عملية دفع أو إعادة محاولة تظهر هنا."
    }
  },
  "invoice": {
    "title": "فاتورة",
    "description": "تفاصيل الفاتورة والدفع.",
    "payNow": "ادفع",
    "attempts": "محاولات الدفع",
    "noAttempts": "لا توجد محاولات دفع.",
    "failedTitle": "فشل دفع هذه الفاتورة",
    "openBody": "الفاتورة بانتظار الدفع.",
    "download": "تنزيل الفاتورة",
    "summary": "ملخص الفاتورة",
    "number": "رقم الفاتورة",
    "issued": "تاريخ الإصدار",
    "paidOn": "تاريخ الدفع",
    "due": "تاريخ الاستحقاق",
    "status": "الحالة",
    "billedTo": "الفاتورة باسم",
    "vatNumber": "الرقم الضريبي",
    "crNumber": "رقم السجل التجاري",
    "paidWith": "دُفعت بـ {{method}} المنتهية بـ {{last4}} في {{date}}.",
    "refundedOn": "استُرد المبلغ كاملًا في {{date}}.",
    "reference": "المرجع",
    "amountDue": "المبلغ المستحق",
    "issuedByDodo": "تصدر Dodo Payments الفاتورة والإيصال وتحسب الضريبة. زر التنزيل يحفظ نسخة PDF من المستند الرسمي.",
    "documentPending": "تصدر Dodo Payments المستند الرسمي بعد الدفع.",
    "voidBody": "أُلغيت هذه الفاتورة لأن الاشتراك انتهى دون دفع. عند التجديد تصدر فاتورة جديدة.",
    "paidWithPaypal": "دُفعت عبر PayPal في {{date}}."
  },
  "details": {
    "company": "الشركة",
    "legalName": "الاسم القانوني",
    "legalNameHint": "كما هو مسجل، ويظهر في فواتيرك.",
    "country": "دولة الفوترة",
    "countryHint": "تحدد الضريبة في فواتيرك.",
    "cr": "رقم السجل التجاري",
    "crHintSa": "10 أرقام",
    "crHint": "كما هو في الرخصة التجارية",
    "noVat": "لا توجد ضريبة قيمة مضافة في {{country}} حاليًا، لذلك تصدر الفواتير بدون رقم ضريبي.",
    "vat": "الرقم الضريبي",
    "vatHint": {
      "SA": "15 رقمًا، يبدأ بـ 3 وينتهي بـ 3. به تصدر الفاتورة باسم شركتك ورقمها الضريبي.",
      "AE": "رقم التسجيل الضريبي: 15 رقمًا يبدأ بـ 100",
      "BH": "15 رقمًا",
      "OM": "OM وبعدها 10 أرقام"
    },
    "address": "العنوان",
    "addressHint": "مطلوب في فواتير الشركات إذا كان لديك رقم ضريبي.",
    "line1": "الشارع والمبنى",
    "line2": "الحي أو الوحدة أو الرقم الإضافي",
    "city": "المدينة",
    "region": "المنطقة",
    "postal": "الرمز البريدي",
    "emails": "بريد الفواتير",
    "emailsHint": "تصل الفواتير والإيصالات إلى هذه العناوين، بحد أقصى 5 عناوين.",
    "primaryEmail": "البريد الأساسي",
    "ccEmail": "البريد {{n}}",
    "removeEmail": "احذف البريد",
    "addEmail": "أضف بريدًا",
    "saved": "تم حفظ بيانات الفوترة",
    "dodo": {
      "title": "فواتيرك من Dodo Payments",
      "body": "Dodo Payments هي البائع المسجل، وتصدر فواتيرك وإيصالاتك. نرسل إليها هذه البيانات لتصدر فواتير الشركات باسمك ورقمك الضريبي.",
      "vatSa": "في السعودية تُضاف ضريبة القيمة المضافة 15٪، ومع الرقم الضريبي تصدر الفاتورة باسم شركتك كمشترٍ.",
      "vatGcc": "خارج السعودية تحسب Dodo Payments الضريبة حسب دولتك وتُظهرها في الفاتورة.",
      "future": "التعديلات تُطبَّق على الفواتير الجديدة، وتبقى الفواتير السابقة ببياناتها."
    }
  },
  "pay": {
    "continue": "متابعة للدفع",
    "setUp": "متابعة لحفظ طريقة الدفع",
    "firstChargeOn": "أول دفعة في {{date}}",
    "later": "يُخصم لاحقًا",
    "first_period": {
      "title": "ادفع أول فترة لـ {{server}}",
      "body": "يحتاج السيرفر إلى أول دفعة قبل التثبيت. بعد الدفع تكمل التثبيت."
    },
    "trial_conversion": {
      "title": "جهّز الدفع لـ {{server}}",
      "body": "تحفظ طريقة الدفع الآن ولا نخصم أي مبلغ اليوم. أول دفعة في {{date}} عند نهاية التجربة."
    },
    "past_due": {
      "title": "ادفع تجديد {{server}}",
      "body": "لم تتم دفعة التجديد. يعمل السيرفر كالمعتاد حتى {{date}}، ثم تُقفل لوحة التحكم حتى تدفع."
    },
    "renewal": {
      "title": "جدّد {{server}}",
      "body": "الاشتراك انتهى في {{date}} ولوحة التحكم مقفلة. التجديد يبدأ فترة جديدة من يوم الدفع.",
      "choose": "طريقة التجديد",
      "keep": "نفس الباقة: {{plan}}، {{cycle}}",
      "keepBody": "بسعرك",
      "switch": "باقة أو دورة فوترة أخرى",
      "switchBody": "بسعر اليوم للباقة التي تختارها.",
      "unlock": "بعد الدفع تُفتح لوحة التحكم عند أول اتصال للسيرفر بـ bPanel، عادةً خلال دقائق. المواقع والبريد لم تتوقف أصلًا."
    }
  },
  "pricing": {
    "yourPrice": "سعرك",
    "todayShort": "سعر اليوم",
    "switchRule": "أي تغيير في الباقة أو دورة الفوترة، ترقيةً أو تخفيضًا، ينقل الاشتراك إلى سعر اليوم للباقة الجديدة. يُطبَّق هذا السعر على دفعة التغيير وعلى كل تجديد بعدها.",
    "keepRule": "التجديد على نفس الباقة ودورة الفوترة يحافظ على سعرك.",
    "newPrice": "سعر {{plan}}، {{cycle}}، من الآن:",
    "leavingYourPrice": "سعرك الحالي الذي ستتركه:",
    "todayPrice": "سعر اليوم لباقتك الحالية:"
  },
  "lock": {
    "reason": {
      "cancelled": "انتهى الاشتراك في {{date}} بعد الإلغاء.",
      "trial_ended": "انتهت التجربة في {{date}} دون تجهيز الدفع.",
      "unpaid": "انتهى الاشتراك في {{date}} لأن دفعة التجديد لم تتم خلال مهلة الدفع.",
      "revoked": "أوقفنا ترخيص هذا السيرفر في {{date}}. تواصل مع الدعم."
    },
    "keepsRunning": "تستمر المواقع والبريد وقواعد البيانات وDNS في العمل، ولا نحذف أي شيء."
  },
  "checkout": {
    "title": "الدفع",
    "back": "رجوع",
    "summary": "ملخص الطلب",
    "purpose": {
      "first_period": "أول فترة للسيرفر",
      "trial_conversion": "حفظ طريقة الدفع",
      "plan_change": "تغيير الباقة",
      "past_due": "دفعة التجديد",
      "renewal": "تجديد الاشتراك",
      "credits": "حزم نقاط الذكاء الاصطناعي",
      "payment_method": "تحديث طريقة الدفع"
    },
    "dueToday": "المطلوب اليوم",
    "later": "أول دفعة في {{date}}:",
    "nothingToday": "لا نخصم أي مبلغ اليوم.",
    "methodBody": "تحل الطريقة الجديدة مكان الحالية في التجديدات القادمة. لا يُخصم أي مبلغ الآن، إلا دفعة تجديد متأخرة إن وُجدت.",
    "frame": "نموذج الدفع",
    "opening": "نجهّز نموذج الدفع",
    "confirming": {
      "title": "نتأكد من الدفع",
      "body": "يستغرق ذلك بضع ثوانٍ.",
      "charged": "يُخصم الفرق من طريقة الدفع المحفوظة، ويستغرق التأكيد بضع ثوانٍ.",
      "method": "نتأكد من حفظ طريقة الدفع. يستغرق ذلك بضع ثوانٍ."
    },
    "slow": {
      "title": "التأكيد يستغرق وقتًا أطول",
      "body": "وصل الدفع ولم يصلنا التأكيد بعد. يمكنك المتابعة، وتتحدث بيانات الفوترة عند وصوله."
    },
    "error": {
      "title": "تعذّر فتح نموذج الدفع",
      "body": "لم يُخصم أي مبلغ. حاول مرة أخرى بعد قليل."
    },
    "expired": {
      "title": "انتهت مدة جلسة الدفع",
      "body": "لم يُخصم أي مبلغ. ارجع وابدأ الدفع من جديد."
    },
    "failed": {
      "title": "لم يكتمل الدفع",
      "body": "رُفض الدفع ولم يُخصم أي مبلغ. ارجع وحاول مرة أخرى، أو استخدم طريقة دفع أخرى."
    },
    "notFound": "جلسة الدفع غير موجودة أو انتهت مدتها. ارجع وابدأ الدفع من جديد.",
    "retry": "حاول مرة أخرى",
    "continue": "متابعة",
    "paid": "المبلغ المدفوع",
    "done": {
      "first_period": {
        "title": "تم استلام الدفع",
        "body": "أول فترة لـ {{server}} مدفوعة. يمكنك إكمال التثبيت الآن."
      },
      "trial_conversion": {
        "title": "تم حفظ طريقة الدفع",
        "body": "كل شيء جاهز لـ {{server}}. أول دفعة عند نهاية التجربة."
      },
      "past_due": {
        "title": "تم استلام الدفع",
        "body": "تم دفع تجديد {{server}}، والاشتراك فعّال."
      },
      "renewal": {
        "title": "تجدد الاشتراك",
        "body": "تجدد اشتراك {{server}}. تُفتح لوحة التحكم عند أول اتصال للسيرفر بـ bPanel."
      },
      "plan_change": {
        "title": "تم تغيير الباقة",
        "body": "أصبح {{server}} على الباقة الجديدة بسعر اليوم."
      },
      "credits": {
        "title": "تمت إضافة النقاط",
        "body": "أُضيفت النقاط إلى رصيد {{server}}."
      },
      "payment_method": {
        "title": "تم تحديث طريقة الدفع",
        "body": "تُستخدم الطريقة الجديدة في التجديدات القادمة."
      }
    }
  }
}
